import { render, staticRenderFns } from "./CustomInstructions.vue?vue&type=template&id=a6ed1512&scoped=true&lang=pug&"
import script from "./CustomInstructions.vue?vue&type=script&lang=js&"
export * from "./CustomInstructions.vue?vue&type=script&lang=js&"
import style0 from "./CustomInstructions.vue?vue&type=style&index=0&id=a6ed1512&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ed1512",
  null
  
)

export default component.exports